import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "priceshow"
}
const _hoisted_2 = { class: "priceshow__container" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Ihr persönliches Angebot ")
const _hoisted_5 = { class: "priceshow__results" }
const _hoisted_6 = { class: "row g-0" }
const _hoisted_7 = { class: "col-12 col-lg-5 order-lg-2 col-xxl-4 col-search" }
const _hoisted_8 = { class: "col-search__sticky" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-saving d-none d-lg-block" }, " Aktuelle Preise für den angegebenen Jahresverbrauch inkl. Umsatzsteuer und gesetzlicher Abgaben. Der Grundpreis wird tagesgenau auf den jeweiligen Abrechnungszeitraum umgerechnet. ", -1)
const _hoisted_10 = { class: "col-12 col-lg-7 col-xxl-8 order-lg-1" }
const _hoisted_11 = { class: "pe-lg-4 pe-xl-5" }
const _hoisted_12 = { class: "row g-4 g-xl-5" }
const _hoisted_13 = {
  key: 0,
  class: "col-12 fs-regular"
}
const _hoisted_14 = { class: "col-12 d-lg-none" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-saving" }, " Aktuelle Preise für den angegebenen Jahresverbrauch inkl. Umsatzsteuer und gesetzlicher Abgaben. Der Grundpreis wird tagesgenau auf den jeweiligen Abrechnungszeitraum umgerechnet. ", -1)

import CartCommodityItem from '@/classes/CartCommidityItem';
import {
  reactive,
  onMounted,
  computed,
  watch,
  ref,
  onBeforeUnmount,
} from 'vue';
import {
  useStore,
} from 'vuex';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import { IoProductAPI } from '@/api';
import ProductCard from '@/components/product/PriceCard.vue';
import Product from '@/classes/Product';
import CartCommodityInterface from '@/interfaces/CartCommodityInterface';
import PriceSearchCard from '@/components/PriceSearchCard.vue';
import PriceshowOtherBranchModal from '@/components/priceshow/PriceshowOtherBranchModal.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();
const router = useRouter();
const stickyCont = ref();

const translateBranch = ($branch: string) => {
  switch ($branch) {
    case 'strom':
      return 'power';
    case 'gas':
      return 'gas';
    default:
      return $branch;
  }
};

const cartCommodity = computed<Array<CartCommodityItem>>(() => store.getters['cart/commodity']);

const routeQueryVars = computed(() => route.query);
const routeParamVars = computed(() => route.params);

const priceshow = reactive({
  loading: false,
  products: [] as Product[],
  params: {
    customerType: `${routeQueryVars.value.gewerbe}` === '1' ? 'business' : 'private',
    double: routeParamVars.value.usageHt ? 1 : 0,
    usage: parseInt(`${routeParamVars.value.usage}`, 10),
    usageHt: parseInt(`${routeParamVars.value.usageHt || 0}`, 10),
    postcode: routeParamVars.value.postcode,
    city: routeQueryVars.value.stadt,
    street: routeQueryVars.value.strasse,
    houseNumber: routeQueryVars.value.hausnummer,
    categories: [translateBranch(routeParamVars.value.branch as string)],
  },
});

const productsSorted = ref<Product[]>([]);

watch(() => priceshow.products, () => {
  productsSorted.value = [...priceshow.products].sort(($pa, $pb) => {
    if (
      ($pa.isRecommended && !routeQueryVars.value.pid)
        || $pa.id === parseInt(routeQueryVars.value.pid as string, 10)
    ) {
      return -1;
    }

    return $pa.getPriceValue('yearly') < $pb.getPriceValue('yearly') ? 1 : -1;
  });
});

const fetchPrices = () => {
  priceshow.loading = true;

  IoProductAPI.getAllWithPrices(priceshow.params).then((data) => {
    priceshow.products = data;
  }).catch(() => {
    priceshow.products = [];
  }).finally(() => {
    priceshow.loading = false;
  });
};

const setPriceshowParams = () => {
  priceshow.params.city = routeQueryVars.value.stadt;
  priceshow.params.street = routeQueryVars.value.strasse;
  priceshow.params.houseNumber = routeQueryVars.value.hausnummer;
  priceshow.params.categories = [translateBranch(routeParamVars.value.branch as string)];
  priceshow.params.postcode = routeParamVars.value.postcode;
  priceshow.params.double = routeParamVars.value.usageHt ? 1 : 0;
  priceshow.params.usage = parseInt(`${routeParamVars.value.usage}`, 10);
  priceshow.params.usageHt = parseInt(`${routeParamVars.value.usageHt || 0}`, 10);
  priceshow.params.customerType = `${routeQueryVars.value.gewerbe}` === '1' ? 'business' : 'private';
};

const showOtherBranchModalProduct = ref<Product | null>(null);

watch(() => ({
  ...routeParamVars.value,
  ...routeQueryVars.value,
}), () => {
  showOtherBranchModalProduct.value = null;
  setPriceshowParams();
  fetchPrices();
}, { deep: true });

onMounted(() => {
  fetchPrices();
});

const hasOtherBranchProductInCart = ($product: Product): boolean => {
  const otherProductsBranchProducts = cartCommodity.value.filter((cartCommodityItem: CartCommodityItem) => (
      cartCommodityItem.product.attributes.price?.params.postcode === $product.attributes.price?.params.postcode
      && cartCommodityItem.product.attributes.price?.params.city === $product.attributes.price?.params.city
      && cartCommodityItem.product.attributes.price?.params.street === $product.attributes.price?.params.street
      && cartCommodityItem.product.attributes.price?.params.houseNumber === $product.attributes.price?.params.houseNumber
      && cartCommodityItem.product.branch !== $product.branch
  ));

  return otherProductsBranchProducts.length > 0;
};

const goToOrder = (): void => {
  showOtherBranchModalProduct.value = null;
  priceshow.loading = true;
  router.push('/bestellung/adresse/');
};

const cartItemKey = ref(routeQueryVars.value.cik);

const clickOrder = ($product: Product) => {
  priceshow.loading = true;

  store.dispatch('cart/add', {
    product: $product,
    cartItemKey: cartItemKey.value,
    params: priceshow.params,
    entry: true,
  }).then((response) => {
    const responseData = response as {
      cartData: {
        commodity: CartCommodityInterface,
        nonCommodity: CartCommodityInterface,
      },
      cartEnabled: boolean,
      cartKey: string,
    };

    if (responseData.cartEnabled) {
      const alreadyHasOtherBranchOnSameAddress = hasOtherBranchProductInCart($product);

      if (!alreadyHasOtherBranchOnSameAddress) {
        priceshow.loading = false;
        showOtherBranchModalProduct.value = $product;
      } else {
        goToOrder();
      }
    } else {
      goToOrder();
    }
  });
};

const setStickyTop = () => {
  const header = document.querySelector('header');
  if (stickyCont.value && header) {
    stickyCont.value.style.top = `${header.offsetHeight}px`;
  }
};

onMounted(() => {
  window.addEventListener('resize', setStickyTop);
  window.addEventListener('load', setStickyTop);
  setStickyTop();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', setStickyTop);
  window.removeEventListener('load', setStickyTop);
});

return (_ctx: any,_cache: any) => {
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_BaseLoader = _resolveComponent("BaseLoader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (! _unref(priceshow).loading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_IoHeadline, {
                "text-align": "start",
                size: "h1"
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: "ps-lg-4 ps-xl-5",
                      ref: (_value, _refs) => {
                        _refs['stickyCont'] = _value
                        stickyCont.value = _value
                      }
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        (!_unref(priceshow).loading)
                          ? (_openBlock(), _createBlock(PriceSearchCard, {
                              key: 0,
                              options: _unref(priceshow).params,
                              "preselected-options": _unref(priceshow).params
                            }, null, 8, ["options", "preselected-options"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_BaseSpacer, {
                          size: "m",
                          class: "d-none d-lg-block"
                        }),
                        _hoisted_9
                      ])
                    ], 512)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productsSorted.value, (product, inx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "col-12",
                            key: `product-${product.id}`
                          }, [
                            _createVNode(ProductCard, {
                              product: product,
                              recommended: product.recommended,
                              position: inx + 1,
                              "is-single": productsSorted.value.length === 1,
                              onOrder: clickOrder
                            }, null, 8, ["product", "recommended", "position", "is-single"])
                          ]))
                        }), 128)),
                        (productsSorted.value.length === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Leider konnten für Ihre Angaben aktuell keine Preise ermittelt werden. "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_BaseSpacer, { size: "m" }),
                    _hoisted_15
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showOtherBranchModalProduct.value)
      ? (_openBlock(), _createBlock(PriceshowOtherBranchModal, {
          key: 1,
          current: showOtherBranchModalProduct.value,
          "priceshow-params": _unref(priceshow).params,
          onDecline: goToOrder
        }, null, 8, ["current", "priceshow-params"]))
      : _createCommentVNode("", true),
    (_unref(priceshow).loading)
      ? (_openBlock(), _createBlock(_component_BaseLoader, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})